import { AlertTriangle, X } from "lucide-react";
import type React from "react";
import type { ProjectWarning } from "@/utils/project";
import { Button } from "./ui/Button";

interface ProjectWarningsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  projectName: string;
  warnings: ProjectWarning[];
}

function ProjectWarningsDialog({ isOpen, onClose, projectName, warnings }: ProjectWarningsDialogProps) {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={handleBackdropClick}>
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-full bg-yellow-100">
              <AlertTriangle className="h-5 w-5 text-yellow-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Problems no Projeto</h3>
              <p className="text-lg text-gray-600 font-bold">{projectName}</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="h-5 w-5" />
          </Button>
        </div>

        {/* Content */}
        <div className="p-4">
          {warnings.length === 0 ? (
            <p className="text-gray-700">Nenhum problema encontrado.</p>
          ) : (
            <div className="space-y-3">
              {warnings.map((warning, index) => (
                <div key={index} className="flex items-start gap-3 p-3 bg-yellow-50 rounded-lg">
                  <AlertTriangle className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                  <p className="text-gray-700">{warning.message}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="flex gap-3 p-4 border-t border-gray-200">
          <Button variant="secondary" onClick={onClose} className="flex-1">
            Fechar
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ProjectWarningsDialog;
